import api from '@/utils/api';

/**
 * Get current logged in user profile
 * @returns {Promise}
 */
const getAccountProfileApi = () => api.get(`user/my-account`);

export default getAccountProfileApi;
